import { Star, ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "../components/Reveal";
import { TESTIMONIALS, GOOGLE_REVIEWS_URL } from "../data/content";

const GoogleG = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
    <path fill="#4285F4" d="M22.5 12.3c0-.8-.1-1.4-.2-2H12v3.8h5.9c-.2 1.3-1 2.4-2.2 3.2v2.6h3.5c2.1-1.9 3.3-4.7 3.3-7.6z" />
    <path fill="#34A853" d="M12 23c3 0 5.5-1 7.3-2.7l-3.5-2.6c-1 .7-2.3 1.1-3.8 1.1-2.9 0-5.4-2-6.3-4.6H2.1v2.7C3.9 20.4 7.7 23 12 23z" />
    <path fill="#FBBC05" d="M5.7 14.2c-.2-.7-.4-1.4-.4-2.2s.1-1.5.4-2.2V7.1H2.1C1.4 8.6 1 10.2 1 12s.4 3.4 1.1 4.9l3.6-2.7z" />
    <path fill="#EA4335" d="M12 5.4c1.7 0 3.1.6 4.3 1.7l3.2-3.2C17.5 2.2 15 1 12 1 7.7 1 3.9 3.6 2.1 7.1l3.6 2.7C6.6 7.3 9.1 5.4 12 5.4z" />
  </svg>
);

const Stars = ({ n = 5 }) => (
  <div className="flex gap-0.5" aria-label={`${n} out of 5 stars`}>
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} size={13} className={i < n ? "fill-[#D4AF37] text-[#D4AF37]" : "text-white/20"} />
    ))}
  </div>
);

// Placeholder Google reviews URL — replace when Blaine shares each centre's Google Business Profile link
const AVERAGE_RATING = 5.0;

export const Testimonials = () => (
  <section id="reviews" className="py-24 sm:py-32 scroll-mt-16 bg-[#050505]" data-testid="reviews-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <Reveal>
        <Overline>What Parents & Players Say</Overline>
        <div className="mt-3 flex flex-wrap items-end justify-between gap-6">
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight max-w-2xl">
            Zavi Football Club <span className="text-[#D4AF37]">on Google.</span>
          </h2>
          <div className="flex items-center gap-3 border border-white/10 px-4 py-2.5 bg-black" data-testid="google-summary">
            <GoogleG />
            <div>
              <div className="flex items-center gap-2">
                <span className="font-heading text-xl font-black text-white">{AVERAGE_RATING.toFixed(1)}</span>
                <Stars n={5} />
              </div>
              <p className="text-white/40 text-[10px] uppercase tracking-widest mt-0.5">Verified Google reviews</p>
            </div>
          </div>
        </div>
      </Reveal>

      <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
        {TESTIMONIALS.slice(0, 6).map((t, i) => (
          <Reveal key={t.name} delay={i * 0.06}>
            <article className="border border-white/10 bg-black p-6 h-full flex flex-col hover:border-[#D4AF37]/30 transition-colors duration-300"
                     data-testid={`review-${i}`}>
              <div className="flex items-center justify-between">
                <Stars n={t.rating || 5} />
                <GoogleG />
              </div>
              <p className="text-white/80 text-sm leading-relaxed mt-4 flex-1">"{t.quote}"</p>
              <div className="mt-5 pt-4 border-t border-white/8">
                <p className="font-heading text-sm font-bold uppercase tracking-tight text-white">{t.name}</p>
                <p className="text-white/45 text-xs mt-0.5">{t.role}</p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.4}>
        <div className="mt-10 text-center">
          <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noreferrer"
            className="inline-flex items-center gap-2 border border-white/20 text-white/80 font-bold uppercase tracking-widest text-xs px-5 py-3 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors duration-200"
            data-testid="google-reviews-cta">
            <GoogleG /> Read All Google Reviews <ArrowUpRight size={14} />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
